import { provideNgReflectAttributes, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection(), provideNgReflectAttributes()], })
  .catch((err) => console.error('Application bootstrap failed:', err));
